import { useTabsContext } from './TabsContext'
import type { TabPanelProps } from './types'
import styles from './Tabs.module.css'

/**
 * Painel de conteúdo de uma aba.
 * Só é visível quando a aba correspondente está ativa.
 */
export function TabPanel({ children, value, className, keepMounted = false }: TabPanelProps) {
  const { activeTab, tabsId } = useTabsContext()
  
  const isActive = activeTab === value
  const tabId = `${tabsId}-tab-${value}`
  const panelId = `${tabsId}-panel-${value}`
  
  // Se keepMounted for false, não renderiza o conteúdo quando oculto
  if (!keepMounted && !isActive) {
    return null
  }
  
  return (
    <div
      id={panelId}
      role="tabpanel"
      aria-labelledby={tabId}
      tabIndex={0}
      hidden={!isActive}
      className={[
        styles.tabPanel,
        isActive && styles.tabPanelActive,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  )
}
